import LightLayout from '../../../../../shared/Layouts/LightLayout'
import taskSandboxCss from '../taskSandbox.module.css'
import css from './eightTaskSandbox.module.css'
import PngDropzone from '../../../../../shared/Dropzone/PngDropzone'
import Textarea from '../../../../../shared/Inputs/Textarea'
import { IImage, ITask } from '../../../../../types/tasks.types'
import useSandboxTask from '../useSandboxTask'
import sandboxCss from '../taskSandbox.module.css'
import { useState } from 'react'
import DeleteConfirmModal from './DeleteConfirmModal'
import InlineSelect from '../../../../../shared/Inputs/InlineSelect'
import { IOption } from '../../../../../shared/Inputs/Dropdown'

const options: IOption<'text_and_image' | 'images'>[] = [
  { value: 'text_and_image', title: 'Текст и картинка' },
  { value: 'images', title: 'Только картинки' },
]

interface IProps {
  onDraftTaskChange: <T extends keyof ITask>(value: ITask[T], key: T) => void
}

const EightTaskSandbox = (props: IProps) => {
  const ctrl = useSandboxTask(props.onDraftTaskChange)
  const [deleteModalOpen, setDeleteModalOpen] = useState(false)

  return (
    <div className={taskSandboxCss.wrapper}>
      {deleteModalOpen && <DeleteConfirmModal onClose={() => setDeleteModalOpen(false)} taskId={ctrl.draftTask.id} />}

      <LightLayout>
        <div style={{ display: 'flex', justifyContent: 'center', paddingTop: '10px' }}>
          <InlineSelect
            value={ctrl.draftTask.type === 8 ? 'text_and_image' : 'images'}
            options={options}
            onChange={(v) => props.onDraftTaskChange(v === 'images' ? 16 : 8, 'type')}
          />
        </div>

        <div
          className={sandboxCss.addOption}
          onClick={() => setDeleteModalOpen(true)}
          style={{ transform: 'translateX(-4px) translateY(-50%)', background: 'var(--alert)' }}
        >
          Удалить слайд
        </div>
        <div className={css.inputContainer}>
          <Textarea
            value={ctrl.draftTask.question ?? ''}
            name="question"
            onChange={props.onDraftTaskChange}
            placeHolder="Текст интро"
          />
        </div>
        <div className={css.wrapper}>
          <div className={css.imageUpload}>
            <PngDropzone onFile={ctrl.handleImage} image={ctrl.draftTask.images[0] as IImage} />
          </div>
        </div>
      </LightLayout>
    </div>
  )
}

export default EightTaskSandbox
